export const fileConstants = {
  DELETE_IMAGE_SUCCESS: 'DELETE_IMAGE_SUCCESS',
  GET_IMAGES_SUCCESS: 'GET_IMAGES_SUCCESS',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
  IMAGE_DELETED_SUCCESS: 'IMAGE_DELETED_SUCCESS'
};
